import { createContext, useContext } from 'react';

export type DrawerState = string | null;

export type DrawerContextState = {
  showDrawer: (eventName: string) => void;
  hideDrawer: () => void;
  eventName: string | null;
};

const defaultState = {
  showDrawer: () => null,
  hideDrawer: () => null,
  eventName: null,
};

export const DrawersContext = createContext<DrawerContextState>(defaultState);

export const useDrawersContext = () => {
  const { showDrawer, hideDrawer, eventName } = useContext(DrawersContext);

  return {
    showDrawer,
    hideDrawer,
    eventName,
  };
};
